{
  "name": "cardoo@6.12.0+104cd5a",
  "version": "6.12.0",
  "gitHash": "104cd5a",
  "generatedAt": "2026-06-18T11:59:37.696Z"
}
